import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ev4u44rmw: FaireProductEntity = {
  token: "p_5ev4u44rmw",
  type: "product",
  name: "Ryb Grid: Cozy Socks",
  brandToken: "b_77ud8qkk62",
  brandName: "Karepango",
  imageUrl:
    "https://cdn.faire.com/fastly/7ce2db7a8dea4f6c4f591d496b94955b8071820933b760006e39424f00a48a30.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b5ead38350fa5abfb2829bf2cddf5050ef7f11147ee7f3a3c86c8f4b9e0ac22.jpeg",
  ],
  priceDollars: 6,
  description:
    "Yeah we finally made socks. Maybe you can finally go outside with them, too.\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:43.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
